import surveyData from "../../data/surveyData";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import React, {useState} from "react";
import Radio from "@material-ui/core/Radio";
import clsx from "clsx";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState} from "../../state/globalState";
import {makeStyles} from "@material-ui/core";


const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    disabledIcon: {
        backgroundColor: '#999',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#999',
        },
    },
    textField: {
        width: '300px'
    },
    textFieldMobile: {
        width: '250px'
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const RadioOptionList = (props) => {
    const {step, column} = props;
    const [answer, setAnswer] = useRecoilState(answerState);
    const classes = useStyles();
    const isKor = answer.IS_KOR;
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);

    const handleInputAnswer = (e, column) => {
        if([32, 61, 77, 83, 102].includes(step)) return;

        const { value } = e.target;
        const key = `SURVEY_${step}`;
        setAnswer({
            ...answer,
            [column]: value
        });
        setSelectedMenuItem(key);
        setMenuCheck(value !== '');
    };
    const StyledRadio = (props) => {
        return (
            <Radio
                key={'survey-' + props.key}
                disableRipple
                color="default"
                checked={answer[`step_${step}`] === props.value}
                checkedIcon={<span className={clsx(classes.icon, [32, 61, 77, 83, 102].includes(step) ? classes.disabledIcon : classes.checkedIcon)} />}
                icon={<span className={classes.icon} />}
                onChange={(e) => handleInputAnswer(e, column)}
                {...props}
            />
        );
    };


    return (
        <>
        {surveyData[step].text.map((item) => (
                <FormControlLabel key={`${step}-` + item.key} name={String(item.toggle)} value={item.key}
                                  control={<StyledRadio key={`rd-step-${step}`}/>} label={item.content}/>
        ))}
        </>
    );
};

export default RadioOptionList;
